export default "__VITE_ASSET__BZOnL5WP__"